import styled, { css } from 'styled-components'

interface DrawerProps {
  open: boolean;
  hidden?: boolean;
}

export const DrawerContainer = styled.div<DrawerProps>`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 99;
  width: ${props => props.open ? '100vw' : '0'};
  height: 100vh;
  background: rgba(0,0,0,0.2);
  ${props => props.hidden === true && css`
    display: none;
  `}
`

export const Drawer = styled.div<DrawerProps>`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 100;
  width: ${props => props.open ? '50%' : '0'};
  min-width: ${props => props.open ? '400px' : '0'};
  max-width: ${props => props.open ? '800px' : '0'};
  height: 100vh;
  background: #F9F5F2;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: 0.2s;
`

export const CloseButtonContainer = styled.div<DrawerProps>`
  position: absolute;
  top: 34px;
  left: -16px;
  width: 32px;
  height: 32px;
  background: #E1712A;
  border: 2px solid #E1712A;
  display: ${props => props.open ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
  cursor: pointer;

  & svg {
    height: 16px;
    width: 16px;
    color: #fff;
  }
`

export const DrawerHeader = styled.div`
  width: 100%; 
  height: fit-content;
  background: #fff;
  box-shadow: 0px 2px 6px rgba(53, 53, 53, 0.12);
`

export const DrawerContent = styled.div`
  width: 100%; 
  height: 100%; 
  overflow: hidden;
`